import axios from 'axios'
import { admin2 } from '@/api/instance'

//= > 取得下載中心任務列表
export const GetSheetExport = async ({
  shopId,
  start,
  limit,
}) => {
  const res = await admin2({
    method: 'get',
    url: `/${shopId}/sheetExportTask`,
    params: {
      start,
      limit,
    },
  })

  return res
}

//= > 取得下載中心任務數量
export const GetSheetExportCount = async ({
  shopId,
  name,
}) => {
  const res = await admin2({
    method: 'get',
    url: `/${shopId}/sheetExportTask/count`,
    params: {
      name,
    },
  })

  return res
}

// 取得下載中心任務
export const FindSheetExport = async ({
  shopId,
  id,
}) => {
  const res = await admin2({
    method: 'get',
    url: `/${shopId}/sheetExportTask/${id}`,
  })

  return res
}

// 取得下載中心任務下載連結
export const GetSheetExportDownloadLink = async ({
  shopId,
  id,
}) => {
  const res = await admin2({
    method: 'post',
    url: `/${shopId}/sheetExportTask/${id}/downloadLink`,
  })

  return res
}

/**
 * 取得臨時上傳連結 admin.sheetExportTask.getTempUploadLink
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店ID
 * @param {string} params.contentType - 檔案 MIME 類型
 * @returns {Promise<Object>} 臨時上傳連結資訊
 * @example
 * // 回傳格式
 * { url: 'https://s3.amazonaws.com/...', objectKey: 'temp-uploads/...' }
 */
export const GetTempUploadLink = async ({
  shopId,
  contentType,
}) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/sheetExportTask/getTempUploadLink`,
    params: {
      contentType,
    },
  })
}

/**
 * 上傳檔案到 S3 presigned URL
 * @param {Object} params - 上傳參數
 * @param {string} params.url - S3 presigned URL
 * @param {File} params.file - 要上傳的檔案
 * @param {Function} [params.onUploadProgress] - 上傳進度回呼
 * @returns {Promise<Object>} axios 回應
 */
export const UploadFileToS3 = async ({
  url,
  file,
  onUploadProgress,
}) => {
  return await axios.put(url, file, {
    headers: {
      'Content-Type': file.type,
    },
    onUploadProgress,
  })
}

/**
 * 建立完成的上傳任務 admin.sheetExportTask.createCompletedTask
 * @param {Object} params - 任務參數
 * @param {string} params.shopId - 商店ID
 * @param {string} params.objectKey - S3 object key
 * @param {string} params.retentionAt - 保留期限 ISO 日期字串
 * @param {string} params.fileName - 檔案名稱
 * @param {string} [params.note] - 備註（選填）
 * @returns {Promise<Object>} 建立的任務資訊
 * @example
 * // 回傳格式
 * { id: 'task-uuid', status: 'completed' }
 */
export const CreateCompletedTask = async ({
  shopId,
  objectKey,
  retentionAt,
  fileName,
  note,
}) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/sheetExportTask/createCompletedTask`,
    data: {
      objectKey,
      retentionAt,
      fileName,
      note,
    },
  })
}
